import {parseCookies} from 'nookies';
import {useCallback, useEffect, useState} from 'react';
import {
  useDeleteFollowCompany,
  useUpdateFollowCompany,
} from '../../../core/repositories/companiesRepository';
import {useAuth} from '../../../core/usecases/auth/AuthContext';
import {canShowFollowCompletionPrompt} from './followCompletionPromptSuppression';

type Props = {
  companyId: number;
  followCount: number;
  followed: boolean;
  open: () => void;
  setFollowCompletionModalOpened: (value: boolean) => void;
};

export function useHandleFollowCompany({
  companyId,
  followCount,
  followed,
  open,
  setFollowCompletionModalOpened,
}: Props) {
  const cookies = parseCookies();
  const {status} = useAuth();
  const [followCountUpdated, setFollowCountUpdated] =
    useState<number>(followCount);
  const [isFollowed, setIsFollowed] = useState<boolean>(followed);

  const updateFollowCompany = useUpdateFollowCompany({
    onSuccessFunc() {
      if (canShowFollowCompletionPrompt()) {
        setFollowCompletionModalOpened(true);
      }

      setIsFollowed(true);
      setFollowCountUpdated(followCountUpdated + 1); // フォロー数ランキング用にAPIのレスポンスを使わないようにする
    },
  });
  const deleteFollowCompany = useDeleteFollowCompany({
    onSuccessFunc() {
      setIsFollowed(false);
      setFollowCountUpdated(followCountUpdated - 1); // フォロー数ランキング用にAPIのレスポンスを使わないようにする
    },
  });

  useEffect(() => {
    setFollowCountUpdated(followCount);
    setIsFollowed(isFollowed);
  }, [companyId]);

  const unFollowCompanyUsecase = useCallback(
    async function unFollowCompanyUsecase() {
      if (status !== 'authenticated') {
        open();
        return;
      }

      deleteFollowCompany.mutate({companyId});
    },
    [companyId, cookies],
  );

  const updateFollowCompanyUsecase = useCallback(
    async function updateFollowCompanyUsecase() {
      if (status !== 'authenticated') {
        open();
        return;
      }

      updateFollowCompany.mutate({companyId});
    },
    [companyId, cookies],
  );

  const handleFollowCompany = useCallback(async () => {
    if (isFollowed) {
      await unFollowCompanyUsecase();
      return;
    }

    await updateFollowCompanyUsecase();
  }, [unFollowCompanyUsecase, isFollowed, updateFollowCompanyUsecase]);

  return {handleFollowCompany, followCountUpdated, isFollowed};
}
